'use strict';

module.exports = {
  H264_STREAM_TYPE: 0x1B,
  ADTS_STREAM_TYPE: 0x0F,
  METADATA_STREAM_TYPE: 0x15
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mux.js/lib/m2ts/stream-types.js
 ** module id = 126
 ** module chunks = 0
 **/